import * as React from 'react';
import ModuleData from './ModuleData';
import { EditViewProps } from '../interfaces';
import ModulHeading from '../ModulHeaderHeading';
import { CKEditorEditView, CKEditorEditViewProps } from '../common/CKEditorEditView';
import { ToolbarItems } from '../../custom-components/ckeditor/CKEditorToolbar';
import { allCKEditorItems as CK } from '../../custom-components/ckeditor/AllCKEditorButtonsConfig';

interface HeadingEditViewProps extends EditViewProps<ModuleData>, CKEditorEditViewProps {
    module: ModulHeading;
}

export class HeadingEditViewBasics extends React.Component<HeadingEditViewProps, {}> {

    render() {
        const items: ToolbarItems = [];
        let {headerFormat} = this.props.module.getData().supports;

        if (headerFormat) {
            items.push(CK.Format);
        }
        items.push(CK.TextStyles(this.props.module));
        items.push(CK.ContactInfo);

        return (
            <CKEditorEditView
                {...this.props}
                key="HeaderBasics"
                items={items}
            />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/heading/EditView.tsx
 **/